import script from "./MenuItemDeal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuItemDeal.vue?vue&type=script&setup=true&lang=ts"

import "./MenuItemDeal.vue?vue&type=style&index=0&id=767a8bfc&lang=scss"

const __exports__ = script;

export default __exports__